<template>
    <div class="main-placeholder grid grid__placeholder">
        <div class="grid--container main-placeholder--container">
            <transition-group name="trs-simple-fade" tag="div" class="grid--row main-placeholder--row">
                <div v-if="pageTitle" class="grid--col grid--col__page-title main-placeholder--col" key="pageTitle">
                    <h1 v-text="pageTitle"></h1>
                </div>
                <component class="grid--col main-placeholder--col"
                        v-if="!isLoading"
                        v-for="(plugin, pluginIdx) in plugins" :key="pluginIdx"
                        :is="plugin.type"
                        :plugin="plugin">
                </component>
            </transition-group>
        </div>
    </div>
</template>

<script>
    import routeMixin from 'framework/mixins/route';
    import cmsPlaceholderMixin from 'framework/mixins/cms/cms-placeholder/index';


    export default {
        mixins: [
            routeMixin,
            cmsPlaceholderMixin,
        ],
        props: {
            pageTitle: {
                type: String,
            },
        },
    };
</script>



// WEBPACK FOOTER //
// vehi-industriepfad/assets/src/js/app/framework/components/cms-placeholders/main-placeholder/index.vue?538f9141